import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-nav',
  templateUrl: './social-nav.component.html',
  styleUrls: ['./social-nav.component.scss']
})
export class SocialNavComponent implements OnInit {

  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
